import {
    SET_WINNERS_REPORT_DATA,
    SET_WINNERS_REPORT_FILTERS,
    CLEAR_WINNERS_REPORT,
} from '../actions/actionTypes';

export const INITIAL_STATE = {
    reportData: null,
    filters: {
        fromDate: null,
        toDate: null,
        gigyaId: '',
        eventType: '',
    },
    page: 0,
    rowsPerPage: 10,
    hasSearched: false,
};

const winnersReportReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_WINNERS_REPORT_DATA: {
            return {
                ...state,
                reportData: action.reportData,
                page: action.page ?? state.page,
                rowsPerPage: action.rowsPerPage ?? state.rowsPerPage,
                hasSearched: true,
            };
        }
        case SET_WINNERS_REPORT_FILTERS: {
            return {
                ...state,
                filters: { ...state.filters, ...action.filters },
            };
        }
        case CLEAR_WINNERS_REPORT: {
            return { ...INITIAL_STATE };
        }
        default: {
            return state;
        }
    }
};

export default winnersReportReducer;
